import { useEffect, useState } from "react";
import { http, FALLBACK_PRODUCT } from "../lib/api";

export const useProduct = () => {
  const [product, setProduct] = useState(FALLBACK_PRODUCT);
  useEffect(() => {
    let alive = true;
    http.get("/product").then((r) => { if (alive && r.data?.price) setProduct({ ...FALLBACK_PRODUCT, ...r.data }); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return [product, setProduct];
};
